<div
    class="account-avatar"
    #userProfile="userProfile"
    lsUserProfile
    #playerScore="playerscore"
    lsPlayerscore
    #vipLevels="vipLevels"
    lsVipLevels
>
    <ng-container *lsUiNgLet="userProfile.userProfileInfo$ | async as userProfileInfo">
        <ng-container *lsUiNgLet="playerScore.score()?.level as currentLevel">
            @if (userProfileInfo?.pictureUrl) {
                <ls-picture
                    class="account-avatar__border"
                    src="achievement/common/achieved-border"
                ></ls-picture>
                <ls-picture
                    class="account-avatar__achievement"
                    [src]="userProfileInfo.pictureUrl | resolveMinioUrlMirror"
                ></ls-picture>
            } @else if (vipLevels.levels()[currentLevel ? currentLevel - 1 : 0]) {
                <ls-picture
                    class="account-avatar__level"
                    [class._entry-level]="currentLevel === 0"
                    [src]="vipLevels.levels()[currentLevel ? currentLevel - 1 : 0].imageUrl"
                ></ls-picture>
            }
        </ng-container>
    </ng-container>
</div>
